import { v4 } from 'uuid';
import { Node } from 'reactflow';

import { CallsMenuStageType, CallsMenuEdgeType } from '@bandido/shared/constants';
import { CommunicationType, StageNodeData, TimeoutAction } from '@bandido/shared/types';

import Stage from './components/Stage';
import Edge from './components/Edge';

export const stageTypes = {
  [CallsMenuStageType.SUB_MENU]: Stage,
  [CallsMenuStageType.ACTION]: Stage,
};

export const edgeTypes = {
  [CallsMenuEdgeType.CUSTOM]: Edge,
};

export const WELCOME_MESSAGE = 'WELCOME_MESSAGE';

export const INITIAL_STAGE: Node<StageNodeData> = {
  id: v4(),
  type: CallsMenuStageType.SUB_MENU,
  data: {
    name: WELCOME_MESSAGE,
    isMain: true,
    audioUrl: '',
    text: 'Hola, te comunicaste con mevuelo. Presiona 1 para ventas, 2 para administración',
    communicationType: CommunicationType.TEXT_TO_SPEECH,
    timeout: 10,
    timeoutAction: TimeoutAction.REPEAT,
  },
  position: {
    x: 0,
    y: 0,
  },
  width: 380,
  height: 103,
};
